import { LogOut } from 'lucide-react'
import { Button } from '@amglobal/ui-shared'
import type { WorkspaceDesk } from '@/config/workspace-desk'
import { deskPortalOrigin } from '@/config/workspace-desk-host'
import { workspaceDeskDisplayName } from '@/shared/lib/staff-capabilities'
import { useLogoutMutation } from '@/features/auth/hooks/use-logout-mutation'

type Props = {
  currentDesk: WorkspaceDesk
  homeDesk: WorkspaceDesk
}

export function WorkspaceDeskBlockedPage({ currentDesk, homeDesk }: Props) {
  const logout = useLogoutMutation()
  const currentName = workspaceDeskDisplayName(currentDesk)
  const homeName = workspaceDeskDisplayName(homeDesk)
  const homeUrl = deskPortalOrigin(homeDesk)

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
      <h1 className="text-xl font-semibold text-text-primary">Access not allowed</h1>
      <p className="mt-3 max-w-md text-sm text-text-secondary">
        You are not authorized to access the {currentName} portal. Your account is for{' '}
        {homeName} use only. Open the portal link that matches your role, or sign out and try
        again.
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <a
          href={homeUrl}
          className="inline-flex h-10 items-center justify-center rounded-lg bg-brand-primary px-4 text-sm font-semibold text-white shadow-sm hover:bg-brand-primary/90"
        >
          Go to {homeName} portal
        </a>
        <Button
          type="button"
          variant="secondary"
          disabled={logout.isPending}
          onClick={() => logout.mutate()}
        >
          <LogOut className="mr-2 h-4 w-4" aria-hidden />
          Sign out
        </Button>
      </div>
    </div>
  )
}
